import { state, availableFields, saveVisibleFields } from '../state';
import { displayVehicles } from './bubble-grid';
import { MEASUREMENT_UNIT_EVENT, setMeasurementUnit, type MeasurementUnit } from '../utils/units';

export function initFilters(): void {
  // Search — debounced to avoid a full re-render on every keystroke
  let searchTimer: ReturnType<typeof setTimeout> | null = null;
  document.getElementById('searchInput')!.addEventListener('input', (e) => {
    state.filters.search = (e.target as HTMLInputElement).value;
    if (searchTimer !== null) clearTimeout(searchTimer);
    searchTimer = setTimeout(() => displayVehicles(state.allVehicles, true), 150);
  });

  // Odometer unit
  const kmBtn = document.getElementById('unitKm')!;
  const miBtn = document.getElementById('unitMi')!;
  const applyUnit = (unit: MeasurementUnit): void => {
    state.odometerUnit = unit;
    const isKm = unit === 'km';
    kmBtn.classList.toggle('active', isKm);
    kmBtn.textContent = isKm ? 'km ×' : 'km';
    miBtn.classList.toggle('active', !isKm);
    miBtn.textContent = isKm ? 'mi' : 'mi ×';
    displayVehicles(state.allVehicles, true);
  };
  applyUnit(state.odometerUnit);
  window.addEventListener(MEASUREMENT_UNIT_EVENT, (e) =>
    applyUnit((e as CustomEvent<MeasurementUnit>).detail));
  kmBtn.addEventListener('click', () => {
    setMeasurementUnit('km');
  });
  miBtn.addEventListener('click', () => {
    setMeasurementUnit('mi');
  });

  // Status + engine chips
  document.querySelectorAll<HTMLButtonElement>('.chip[data-filter]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const filterType = btn.dataset.filter!;
      const isEngine   = btn.dataset.engine === 'true';

      if (['healthy', 'warning', 'critical'].includes(filterType)) {
        btn.classList.toggle('active');
        if (state.filters.status.includes(filterType)) {
          state.filters.status = state.filters.status.filter((f) => f !== filterType);
        } else {
          state.filters.status.push(filterType);
        }
        const labels: Record<string, string> = { healthy: 'Healthy', warning: 'Warning', critical: 'Critical' };
        btn.textContent = state.filters.status.includes(filterType)
          ? labels[filterType] + ' ×'
          : labels[filterType];
      } else if (isEngine) {
        document.querySelectorAll<HTMLButtonElement>('.chip[data-engine="true"]').forEach((c) => {
          c.classList.remove('active');
          c.textContent = c.dataset.filter === 'running' ? 'Running' : 'Off';
        });
        if (state.filters.engine.includes(filterType)) {
          state.filters.engine = [];
        } else {
          state.filters.engine = [filterType];
          btn.classList.add('active');
          btn.textContent = (filterType === 'running' ? 'Running' : 'Off') + ' ×';
        }
      }
      displayVehicles(state.allVehicles, true);
    });
  });
}

/** Clear all active filters + search and reset the chip UI. Called on logout so a freshly
 *  opened database doesn't inherit the previous session's filters. */
export function resetFilters(): void {
  state.filters.search = '';
  state.filters.status = [];
  state.filters.engine = [];

  const search = document.getElementById('searchInput') as HTMLInputElement | null;
  if (search) search.value = '';

  document.querySelectorAll<HTMLButtonElement>('.chip[data-filter]').forEach((btn) => {
    btn.classList.remove('active');
    const f = btn.dataset.filter!;
    btn.textContent = f.charAt(0).toUpperCase() + f.slice(1);
  });
}

export function initFieldSelector(): void {
  const toggle   = document.getElementById('fieldSelectorToggle')!;
  const dropdown = document.getElementById('fieldSelectorDropdown')!;
  const container = document.getElementById('fieldCheckboxes')!;

  toggle.addEventListener('click', () => dropdown.classList.toggle('show'));
  document.addEventListener('click', (e) => {
    if (!toggle.contains(e.target as Node) && !dropdown.contains(e.target as Node)) {
      dropdown.classList.remove('show');
    }
  });

  container.innerHTML = '';
  Object.keys(availableFields).forEach((fieldKey) => {
    const field = availableFields[fieldKey];
    const div   = document.createElement('div');
    div.className = 'field-checkbox';
    div.innerHTML = `<input type="checkbox" id="field_${fieldKey}" ${
      state.visibleFields.includes(fieldKey) ? 'checked' : ''
    }><label for="field_${fieldKey}">${field.label}</label>`;
    container.appendChild(div);

    div.querySelector('input')!.addEventListener('change', (e) => {
      if ((e.target as HTMLInputElement).checked) {
        if (!state.visibleFields.includes(fieldKey)) state.visibleFields.push(fieldKey);
      } else {
        state.visibleFields = state.visibleFields.filter((f) => f !== fieldKey);
      }
      saveVisibleFields();
      displayVehicles(state.allVehicles, true);
    });
  });
}
